import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
// Element
import ElementUI, { MessageBox } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// flex 布局库
import 'flex.css';
// 组件
import '@/components';
// svg 图标
import '@/assets/svg-icons';
// 国际化
import _i18n from '@/i18n.js';

// 功能插件
import pluginError from '@/plugin/error';
import pluginLog from '@/plugin/log';
import pluginOpen from '@/plugin/open';
import zzzjPlugin from '@zzzj/zzzj/src/plugin';
import dialog from '@zzzj/zzzj/src/components/dialog';
export default {
  install: function install(Vue, options) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            // 设置为 false 以阻止 vue 在启动时生成生产提示
            // https://cn.vuejs.org/v2/api/#productionTip
            Vue.config.productionTip = false;
            // 当前环境
            Vue.prototype.$env = process.env.NODE_ENV;
            // 当前的 baseUrl
            Vue.prototype.$baseUrl = process.env.BASE_URL;
            // 当前版本
            Vue.prototype.$version = process.env.VUE_APP_VERSION;
            // 构建时间
            Vue.prototype.$buildTime = process.env.VUE_APP_BUILD_TIME;
            // Element
            Vue.use(ElementUI, {
              i18n: function i18n(key, value) {
                return _i18n.t(key, value);
              }
            });
            // 插件
            Vue.use(pluginError);
            Vue.use(pluginLog);
            Vue.use(pluginOpen);
            Vue.prototype.$dialog = dialog;
            zzzjPlugin(Vue, MessageBox);
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  }
};